module.exports = __webpack_public_path__ + "media/src/assets/images/contact-bg-2acda2041bf8fc67b5b479aaef311720.jpg";